'use client';

import { type FC, useEffect } from 'react';

import { useAtomValue } from 'jotai';

import { formStateAtom } from '@core/Atoms/Pdp/FormState.atom';
import { searchParamsAtom } from '@core/Atoms/SearchParams/SearchParams.atom';
import { userIdAtom } from '@core/Atoms/User/UserId.atom';
import type { TrackingEvent } from '@tracking/Entities/Schema.entity';
import { marketingToEvent } from '@tracking/Schemas/Marketing/MarketingToEvent';
import { userContextToEvent } from '@tracking/Schemas/UserContext/UserContextToEvent';
import { trackCustomEvent } from '@tracking/Utils/TrackCustomEvent';

export const TrackCustomPageEvent: FC<{
  event?: TrackingEvent;
  context?: TrackingEvent[];
}> = ({ event, context }) => {
  let newContext = [...context!];

  const userId = useAtomValue(userIdAtom);
  const formState = useAtomValue(formStateAtom);
  const searchParams = useAtomValue(searchParamsAtom);

  useEffect(() => {
    const marketingDataObj = {
      marketingValues: { ...searchParams },
    };
    const marketingEvent = marketingToEvent(marketingDataObj);
    const userData = {
      userId,
      values: { ...formState },
    };
    const userEvent = userContextToEvent(userData);
    newContext = [...context!, userEvent, marketingEvent];

    trackCustomEvent({
      event: event!,
      context: newContext!,
    });
  }, []);

  if (typeof window === 'undefined') return null;

  return null;
};
